import React from 'react'
import styled from 'styled-components'
import { ExportStatus } from '../types'
import { useTranslate } from '@ur-solutions/react-hooks'
import { Icon, Tooltip } from '@ur-solutions/react-components'

const Wrapper = styled.div`
  display: flex;
  padding-right: 1rem;
`
interface PillProps {
  status: ExportStatus['status']
}
const Pill = styled.div<PillProps>`
  position: relative;

  padding: 0.75rem 1rem calc(0.75rem - 1px);

  border-radius: 999px;
  background-color: ${props =>
    props.status === 'pending'
      ? '#5959e9'
      : props.status === 'error'
      ? '#bc0202'
      : '#0b970b'};
  color: ${props => props.theme.colors.white};
  user-select: none;

  span.progress {
    font-weight: 700;
  }
`

interface UserExportProgressProps {
  status: ExportStatus
}

export const UserExportProgress: React.CFC<UserExportProgressProps> = ({
  status: { status, message },
}) => {
  const translations = useTranslate({
    pending: 'exports.status.pending',
    error: 'exports.status.error',
    success: 'exports.status.success',
  })

  return (
    <Wrapper>
      <Pill status={status}>
        <Icon
          icon={
            status === 'pending'
              ? 'sync'
              : status === 'error'
              ? 'exclamation-circle'
              : 'check-circle'
          }
          type="solid"
          color="white"
          fixedWidth
          margin="0 0.5rem 0 0"
        />

        <span>{translations[status]}</span>

        {status === 'pending' && (
          <span className="progress">&nbsp;{message}%</span>
        )}

        {status === 'error' && (
          <Tooltip background="black" placement="bottom-center">
            {message}
          </Tooltip>
        )}
      </Pill>
    </Wrapper>
  )
}
